export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];

export const info = {
    initials: "CV",
    gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
    baseColor: colors[0],
}